import React from "react";
import PropTypes from "proptypes";
import passport from "./../../../assets/example-passport-photo.jpg";

const PassportModal = ({ closeModal }) => (
  <div>
    <div className="row">
      <button className="square-icon right" onClick={closeModal}>
        X
      </button>
    </div>
    <h3>Passport Photo Example</h3>
    <img id="passport" src={passport} alt="passport" height={"400px"} />
  </div>
);

PassportModal.propTypes = {
  closeModal: PropTypes.func.isRequired
};

export default PassportModal;
